import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["level", "appear", "noSemantics", "margin", "wrapperClassName", "className", "children"],
  _excluded2 = ["subtitle", "containerProps", "titleProps", "subtitleContainerProps", "subtitleProps", "level", "wrapperRow", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classNames from 'classnames';
import DixuContainer from "../DixuContainer/DixuContainer";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuText from "../DixuText/DixuText";
import React from 'react';
const DixuTitle = _ref => {
  let {
      level,
      appear,
      noSemantics,
      margin,
      wrapperClassName,
      className,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const appearedLevel = appear || level;
  const wrapperClasses = classNames('dixu-title-wrapper', {
    [`m-b-${margin}`]: margin
  }, wrapperClassName);
  const classes = classNames('dixu-title', className);
  const font = {
    '1': '7',
    '2': '6',
    '3': '5',
    '4': '4',
    '5': '3'
  }[appearedLevel];
  const Tag = noSemantics ? 'div' : `h${level}`;
  return /*#__PURE__*/React.createElement(Tag, {
    className: wrapperClasses
  }, /*#__PURE__*/React.createElement(DixuText, _objectSpread({
    className: classes,
    responsive: true,
    color: '2-8',
    block: true,
    font
  }, rest), children));
};
DixuTitle.defaultProps = {
  appear: undefined,
  noSemantics: false,
  margin: 8,
  wrapperClassName: undefined
};
const DixuPageTitle = _ref2 => {
  let {
      subtitle,
      containerProps,
      titleProps,
      subtitleContainerProps,
      subtitleProps,
      level,
      wrapperRow,
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const Tag = titleProps?.noSemantics ? 'div' : 'header';
  return /*#__PURE__*/React.createElement(Tag, rest, /*#__PURE__*/React.createElement(DixuContainer, _extends({
    maxWidth: "xl",
    verticalPadding: false,
    horizontalPadding: false
  }, containerProps), /*#__PURE__*/React.createElement(DixuRow, _extends({
    gutter: [0, {
      xs: 12,
      md: 16
    }]
  }, wrapperRow), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuTitle, _extends({
    align: "center",
    weight: "bold",
    margin: "0",
    whiteSpace: "pre-line",
    level: level,
    hyphens: true
  }, titleProps), children)), subtitle && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuContainer, _extends({
    horizontalPadding: false,
    verticalPadding: false,
    maxWidth: "lg"
  }, subtitleContainerProps), /*#__PURE__*/React.createElement(DixuTitle, _extends({
    level: "4",
    color: "2-7",
    align: "center",
    weight: "medium",
    margin: "0",
    style: _objectSpread({}, subtitleProps?.style),
    responsive: true,
    noSemantics: true
  }, subtitleProps), subtitle))))));
};
DixuPageTitle.defaultProps = {
  subtitle: undefined,
  containerProps: undefined,
  titleProps: undefined,
  subtitleProps: undefined,
  subtitleContainerProps: undefined,
  level: '1',
  wrapperRow: undefined
};
DixuTitle.PageTitle = DixuPageTitle;
export default DixuTitle;